import React, { useEffect, useState } from 'react'
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import BtnSpinner from '../../components/BtnSpinner';
import UploadDocuments from './UploadDocuments';

function UserEnrollments({ close, user, setRefresh }) {

  // console.log(user,'user')
  const [allCourses, setAllCourses] = useState([]);
  const token = localStorage.getItem("token");
  const [checkedCourses, setCheckedCourses] = useState([]);
  const [activeTab, setActiveTab] = useState("tab1");
  const [loading, setLoading] = useState({ state: false, name: "" })

  const handleCheckboxChange = (id) => {
    setCheckedCourses((prevCheckedCourses) => {
      if (prevCheckedCourses?.includes(id)) {
        return prevCheckedCourses?.filter((prevId) => prevId !== id);
      } else {
        return [...prevCheckedCourses, id];
      }
    });
  };


  const getAllCourses = async () => {
    try {
      const res = await Apirequests(
        "courses/get-courses",
        "GET",
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );

      //   console.log(res, "results");

      if (res?.success) {
        setAllCourses(
          res.data?.filter((course) => course?.course_status === "Active")
        );
      }
    } catch (error) {
      console.log(error, "courses res");
    }
  };

  useEffect(() => {
    getAllCourses();
  }, []);

  useEffect(() => {
    // const enrolledCourseIds = user?.enrolled_courses.map(
    //   (course) => course._id
    // );
    // console.log(enrolledCourseIds, "course");
    setCheckedCourses(user?.enrolled_courses);
  }, [user]);

  // console.log(allCourses,'allcourses',checkedCourses )

  const handleUpdate = async () => {
    // console.log(checkedCourses, 'checked');
    setLoading({ state: true, name: "update_enrollment" })

    try {
      const res = await Apirequests(`users/update-user/${user?._id}`, 'PUT', {
        name: user?.name,
        email: user?.email,
        phone: user?.phone,
        enrolled_courses: checkedCourses
      }, {
        Authorization: `Bearer ${token}`
      });

      if (res.success) {
        SuccessTost(res.message || "User updated successfully.");
        close();
        setRefresh((prev) => !prev); // Trigger parent refresh
      } else {
        ErrorTost(res.message || "Something went wrong.");
      }
    } catch (error) {
      console.log(error, 'edit enrollment error')
      ErrorTost("Something went wrong,please try again later.")
    }
    setLoading({ state: false, name: "" })
  }





  return (
    <div>

      <div className="flex justify-around border p-2 rounded-lg">
        <button
          className={`w-full py-2 px-4 focus:outline-none rounded-lg ${activeTab === "tab1"
            ? "bg-blue-500 text-white"
            : "text-gray-500 hover:bg-gray-200"
            }`}
          onClick={() => setActiveTab("tab1")}
        >
          Tab 1
        </button>
        <button
          className={`w-full py-2 px-4 focus:outline-none rounded-lg ${activeTab === "tab2"
            ? "bg-blue-500 text-white"
            : "text-gray-500 hover:bg-gray-200"
            }`}
          onClick={() => setActiveTab("tab2")}
        >
          Tab 2
        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-4 p-4 bg-gray-100 rounded overflow-x-auto">
        {activeTab === "tab1" && (
          <div>
            <table>
              <thead>
                <tr>
                  <th className="p-3 text-black dark:text-neutral-500">
                    Course Id
                  </th>
                  <th className="p-3 text-black dark:text-neutral-500">
                    Course Name
                  </th>
                  <th className="p-3 text-black dark:text-neutral-500">
                    Course Price
                  </th>
                </tr>
              </thead>
              <tbody>
                {allCourses.map((course) => {
                  const isChecked = checkedCourses?.includes(
                    course._id
                  );

                  return (
                    <tr key={course.course_id}>
                      <th
                        scope="col"
                        className="ps-6 py-3 text-start"
                      >
                        <label className="flex">
                          <input
                            type="checkbox"
                            className="shrink-0 border-gray-300 rounded text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-600 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                            checked={isChecked}
                            onChange={() =>
                              handleCheckboxChange(course._id)
                            }
                          />
                          <span className="sr-only">Checkbox</span>
                        </label>
                      </th>
                      <td className="p-3 text-black dark:text-neutral-500 text-xs">
                        {course.course_id}
                      </td>
                      <td className="p-3 text-black dark:text-neutral-500">
                        {course.course_title}
                      </td>
                      <td className="p-3 text-black dark:text-neutral-500">
                        ₹ {course.course_price}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {activeTab === "tab2" && (
          <div>
            <p>This is the content for 2.</p>
          </div>
        )}

      </div>

      <button className='py-2 px-10 rounded-lg bg-yellow-400 mt-10 font-bold' onClick={handleUpdate}>{loading.state && loading.name === "update_enrollment" ? <BtnSpinner /> : "Update"} </button>

      <UploadDocuments user={user} setRefresh={setRefresh} close={close}/>
    </div>
  )
}

export default UserEnrollments